import PropTypes from 'prop-types';

import { classNamePropTypes } from 'proptypes';

import { withError, withLabel, withState } from '../enhancers';
import CoreInput from './CoreInput';


const TextInput = withError(withLabel(CoreInput));

TextInput.propTypes = {
  /** props added by withError */
  status: PropTypes.oneOf(['fail']),
  error: PropTypes.string,
  keepErrorIndent: PropTypes.bool,

  /** inherited from withIcon */
  Icon: PropTypes.func,
  iconAlt: PropTypes.string,
  isClearable: PropTypes.bool,
  onIconClick: PropTypes.func,
  onClear: PropTypes.func,

  /** inherited from withCleanup */
  autoTrim: PropTypes.bool,
  trimInitialValue: PropTypes.bool,

  /** inherited from View */
  size: PropTypes.oneOf(['big']),
  className: classNamePropTypes,

  /**
   * some notable default input props are listed here
   * all the other props are simply passed down
   */
  value: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

TextInput.defaultProps = {
  value: '',
  keepErrorIndent: false,
};

export default TextInput;


/**
 * stateful version accepts all the same propTypes,
 * except for `value`
 */
export const StatefulTextInput = withState(TextInput);
